import { useState } from 'react'
import type { Unit } from '@/api/pending'
import { filterUnits } from '@/lib/desk'
import { firstName } from '@/lib/format'
import { Chip, Eyebrow, Spinner } from '@/ui'
import styles from './desk.module.css'
import { deskStrings } from './strings'

interface UnitPadProps {
  units: Unit[] | undefined
  value: number | undefined
  onPick: (unit: Unit) => void
}

/** Autofocused search input plus unit chips: number prefix, tower or resident name. */
export function UnitPad({ units, value, onPick }: UnitPadProps) {
  const [q, setQ] = useState('')
  const hits = units ? filterUnits(units, q) : []
  const t = deskStrings.unitPad
  return (
    <div className={styles.pad}>
      <Eyebrow>{t.label}</Eyebrow>
      <input
        className={styles.padInput}
        value={q}
        onChange={(e) => setQ(e.target.value)}
        inputMode="numeric"
        autoComplete="off"
        placeholder={t.placeholder}
        aria-label={t.label}
        data-autofocus=""
      />
      <div className={`${styles.chips} ${styles.unitChips}`}>
        {!units && <Spinner size={18} label={t.loading} />}
        {hits.map((u) => (
          <Chip key={u.id} selected={u.id === value} onClick={() => onPick(u)}>
            {u.number} · {u.tower}
            {u.residents[0] ? ` · ${firstName(u.residents[0].name)}` : ''}
          </Chip>
        ))}
        {units && !hits.length && <span className={styles.muted}>{t.none(q)}</span>}
      </div>
    </div>
  )
}
